import useActiveGames from '@/src/hooks/data/useActiveGames'
import styles from './ActiveGamesButton.module.css'
import React from 'react'
import { useNavigate } from 'react-router';
import { FaChevronRight } from 'react-icons/fa';

export default function ActiveGamesButton({ absolute = true }) {
    const activeGames = useActiveGames();
    const navigate = useNavigate();

    const handleActiveGamesClick = () => {
        navigate('/game');
    }

    return activeGames.length > 0 && (
        <div onClick={handleActiveGamesClick} className={`${absolute ? styles.activeGamesContainer : styles.activeGamesContainerRelative}`}>
            <div className={styles.activeGamesRelativeContainer}>
                <div className={styles.activeGamesHeader}>
                    <div className={styles.activeGamesCountContainer}>
                        <h2 className={styles.activeGamesCountText}>{activeGames.length}</h2>
                    </div>
                    <div className={styles.activeGamesHeaderTextContainer}>
                        <h2 className={styles.activeGamesHeaderText}> Active {activeGames.length === 1 ? 'Game' : 'Games'}</h2>
                        {/* Right Chevron from React-Icons */}
                        <FaChevronRight color='var(--color-primary)' size={10} />
                    </div>
                </div>
            </div>
        </div>
    )
}

